export const clearBiodata = () => {
  localStorage.removeItem('biodata');
};

export const clearAnalisa = () => {
  localStorage.removeItem('analisa');
};
